<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadAnnouncements(1, null, true)">
      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="modals.add=true">{{ $t('add') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('title')" v-model="announcementSearchParams.title" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <v-select :options="publishStatusOptions" :reduce="label => label.value" :placeholder="$t('publish')" v-model="announcementSearchParams.is_published" class="mb-4 md:mb-0" />
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadAnnouncements(1, null, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="announcementDataContainer" :title="$t('announcements')" class="mb-8 vs-con-loading__container">
      <shared-announcement-list
        :announcements="announcements"
        :isAction="true"
        :isEdit="true"
        :isSeen="true"
        @customClickEdit="editAnnouncementPopup"
        @customClickView="view"
        @customClickDelete="destroy"
      ></shared-announcement-list>

      <template slot="footer">
        <paginate
          :total="announcementPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadAnnouncements"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>

    <modal :title="$t('add_announcement')" id="addAnnouncement" :active.sync="modals.add" size="md">
      <div id="announcementAddFormDataContainer" class="vs-con-loading__container">
        <shared-announcement-add
          @success="onStoreSuccess"
        ></shared-announcement-add>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="addAnnouncementButton" color="primary" type="filled" @click.prevent="storeAnnouncement">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>

    <modal :title="$t('edit_announcement')" id="editAnnouncement" :active.sync="modals.edit" size="md">
      <div id="announcementEditFormDataContainer" class="vs-con-loading__container">
        <shared-announcement-edit
          @success="onUpdateSuccess"
        ></shared-announcement-edit>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="updateAnnouncementButton" color="primary" type="filled" @click.prevent="updateAnnouncement">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>

    <vs-popup
      :title="$t('view_announcement')"
      :active.sync="modals.view">
      <shared-announcement-view :is-visible="modals.view"></shared-announcement-view>
    </vs-popup>
  </div>
</template>

<script>
import Announcements from '@/models/Announcements'
import Modal from '@/components/Modal'
import Utils from '@/helpers/utils'
import {EventBus} from '../../../eventbus'
import Paginate from '@/mixins/paginate'
import SharedAnnouncementList from '@/views/Shared/Announcement/List'
import SharedAnnouncementAdd from '@/views/Shared/Announcement/Add'
import SharedAnnouncementEdit from '@/views/Shared/Announcement/Edit'
import SharedAnnouncementView from '@/views/Shared/Announcement/View'
import announcementSocket from '@/libs/sockets/announcements'
import { publishStatusOptions } from '@/config/options'

export default {
  name: 'Admin.Announcements',
  mixins: [Paginate],
  components: {
    Modal,
    SharedAnnouncementList,
    SharedAnnouncementAdd,
    SharedAnnouncementEdit,
    SharedAnnouncementView
  },
  data () {
    return {
      announcements: {},
      announcementPages: 1,
      announcementListCount: 0,
      itemPerPage: null,
      announcementSearchParams: {
        title: '',
        is_published: ''
      },
      publishStatusOptions,
      // Modals/Popup
      modals: {
        add: false,
        edit: false,
        view: false
      }
    }
  },
  mounted () {
    this.loadAnnouncements(this.initialPage, null)
    this.$windowOpenerHelper.listenToPopUpMessage('reload_announcements_table', this.loadAnnouncements)

    // Initialize Socket IO
    announcementSocket.setNode({
      // TODO: Add backend settings for this.
      announcements: {
        domain: 'http://58.229.253.166',
        port: '3031',
        pivot: {
          namespace: 'announcements'
        }
      }
    })
  },
  methods: {
    async loadAnnouncements (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#announcementDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      const response = await Announcements.all({ ...this.announcementSearchParams, page, itemPerPage })
      this.announcements = response.data.data
      this.announcementPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#announcementDataContainer > .con-vs-loading')
    },
    view (id) {
      this.modals.view = true
      EventBus.$emit('initAnnouncementViewData', id)
    },
    editAnnouncementModal (id) {
      this.modals.edit = true
      EventBus.$emit('initAnnouncementGetFormData', id)
    },
    editAnnouncementPopup (id) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'edit-announcement', {id}, this.editAnnouncementModal)
    },
    updateAnnouncement () {
      EventBus.$emit('initUpdateAnnouncement')
    },
    onUpdateSuccess () {
      this.modals.edit = false
      this.loadAnnouncements()
    },
    addAnnouncementModal () {
      this.modals.add = true
    },
    addAnnouncementPopup (id) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'add-announcement', {id}, this.addAnnouncementModal)
    },
    storeAnnouncement () {
      EventBus.$emit('initSaveAnnouncement')
    },
    onStoreSuccess () {
      this.modals.add = false
      this.loadAnnouncements()
    },
    async destroy (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        const response = await Announcements.destroy({ id })

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.loadAnnouncements(1, null)
      }
    }
  }
}
</script>

<style scoped>

</style>

